import React from "react";
import { useServices } from "../../contexts/ServiceContext";

interface Props {
    fill: string;
}

export const TrophyIcon: React.FC<Props> = ({ fill }) => {
    const { edgeDeploy } = useServices();
    return (
        <svg height="24px" viewBox="0 0 24 24" width="24px" fill={fill} className={edgeDeploy ? "edgeTrophy" : ""}>
            <path
                d="M19,5h-2V3H7v2H5C3.9,5,3,5.9,3,7v1c0,2.6,1.9,4.6,4.4,4.9c0.6,1.5,2,2.6,3.6,3V19H7v2h10v-2h-4v-3.1c1.6-0.3,3-1.5,3.6-3
	                C19.1,12.6,21,10.6,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.8C5.8,10.4,5,9.3,5,8z M19,8c0,1.3-0.8,2.4-2,2.8V7h2V8z"
            />
        </svg>
    );
};
